import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Card, Table, List, Header, Icon } from "semantic-ui-react";
import { getIconByType } from "../resources/resourceIcon/ResourceIconMap.js";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../marking/ResourceMarker.jsx";
import UsageGrid from "../usage/UsageGrid.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { USER_RESOURCE_KEYS } from "../../constants/entity.js";

import projectSelector from "../../state/reducers/projects/projectSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectCard extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    small: PropTypes.bool.isRequired,
    project: PropTypes.object,
    onDelete: PropTypes.func,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    small: false
  };

  // -- HANDLERS -- //

  handleDelete = () => {
    const { onDelete, project } = this.props;
    onDelete(project["@id"]);
  };

  // -- RENDER SMALL CARD -- //

  renderResourceListItems = () => {
    const { project } = this.props;

    return USER_RESOURCE_KEYS.map(type => {
      if (project.hasOwnProperty(type)) {
        return (
          <List.Item key={`${project.id}-${type}`}>
            <Icon name={getIconByType(type)} />
            <List.Content>{project[type].length}</List.Content>
          </List.Item>
        );
      }
    });
  };

  renderSmallCard = () => {
    const { project, copy } = this.props;

    return (
      <Card
        fluid
        as={LinkWithReset}
        to={project["@id"]}
        className="small-project-card"
      >
        <Card.Content>
          <ResourceMarker marking={project.marking} className="float-right" />
          <Card.Header>{project.name}</Card.Header>
        </Card.Content>

        <Card.Content>
          <Header sub>{copy("project_card.resources")}:</Header>
          <List horizontal>{this.renderResourceListItems()}</List>
        </Card.Content>

        {this.renderUsage(Card.Content)}
      </Card>
    );
  };

  // -- RENDER REGULAR CARD -- //

  renderResourceTableHeaderCells = () => {
    const { project, copy } = this.props;

    return USER_RESOURCE_KEYS.map(type => {
      if (project.hasOwnProperty(type)) {
        return (
          <Table.HeaderCell key={`${type}-header`}>
            {copy(`project_card.${type}`)}
          </Table.HeaderCell>
        );
      }
    });
  };

  renderResourceTableCells = () => {
    const { project } = this.props;

    return USER_RESOURCE_KEYS.map(type => {
      if (project.hasOwnProperty(type)) {
        return (
          <Table.Cell key={`${project.id}-${type}`}>
            <Icon name={getIconByType(type)} size="big" />
            <span className="active-num">{project.currentlyActive[type]}</span>
            {` / ${project[type].length}`}
          </Table.Cell>
        );
      }
    });
  };

  renderRegularCard = () => {
    const { project, onDelete, copy } = this.props;

    return (
      <Card fluid className="project-card">
        <Card.Content>
          <ActionDropdownMenu
            viewPath={project["@id"]}
            onDelete={onDelete ? this.handleDelete : null}
            data={project}
            copy={copy("project_dropdown_menu")}
          />
          <ResourceMarker
            marking={project.marking}
            className="float-right-margin"
          />
          <Card.Header as={LinkWithReset} to={project["@id"]}>
            {project.name}
          </Card.Header>

          <LinkWithReset to={project["@id"]} className="card-link-table">
            <Table
              textAlign="center"
              className="resource-table show-pointer"
              unstackable
            >
              <Table.Header>
                <Table.Row>{this.renderResourceTableHeaderCells()}</Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>{this.renderResourceTableCells()}</Table.Row>
              </Table.Body>
            </Table>
          </LinkWithReset>

          {this.renderUsage(Segment)}
        </Card.Content>
      </Card>
    );
  };

  // -- RENDER -- //

  renderUsage = WrapperComponent => {
    const { project } = this.props;

    if (project.charge || project.usage) {
      return (
        <WrapperComponent>
          <UsageGrid
            chargeData={get(project, "charge.charge", undefined)}
            usageData={get(project, "usage.usage", undefined)}
            copyKey="project_card.usage_grid"
          />
        </WrapperComponent>
      );
    }
  };

  render() {
    const { project, small } = this.props;

    if (!project) return null;

    if (small) return this.renderSmallCard();

    return this.renderRegularCard();
  }
}

const mapStateToProps = (state, props) => ({
  isFetching: state.projects.isFetching,
  project: projectSelector.selectProject()(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectCard);
